export default "__VITE_ASSET__Dbwgiad6__"